import styled from "styled-components";
import { colors, types } from "../../../libs";

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: ${colors.background.lightBlack};
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
  width: 100%;
  cursor: pointer;
`;

export const LeftSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.div`
  ${types.body.normal};
  font-weight: bold;
  color: ${colors.text.white};
`;

export const Badge = styled.span<{ $active?: boolean }>`
  ${types.body.small};
  color: ${({ $active }) => ($active ? colors.text.green : colors.text.gray)};
  background: ${({ $active }) =>
    $active ? colors.background.darkGradient : colors.background.lightGrey};
  padding: 3px 8px;
  border-radius: 12px;
`;

export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 520px;
`;

export const Metrics = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  margin-right: 20px;
`;

export const Metric = styled.div`
  text-align: center;
  min-width: 64px;
`;

export const MetricValue = styled.div`
  ${types.body.normal};
  color: ${colors.text.white};
  font-weight: 600;
`;

export const MetricLabel = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionIcon = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: ${colors.background.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.text.white};
  cursor: pointer;

  &:hover {
    background: ${colors.background.greyWhite};
  }
`;

export const Circle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${colors.background.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.text.white};
  cursor: pointer;
`;
